<section class="alert" [ngClass]="[type === alertType.INFORMATION ? 'alert_info-container' : '' ,
type === alertType.WARNING ? 'alert_warning-container' : '',
type === alertType.ERROR ?'alert_error-container': '']">
  <p class="alert__text">{{text}}</p>
</section>
